import { createRoute } from "@tanstack/react-router";
import { useState } from "react";
import { ApiError } from "../../shared/api/http.js";
import { Button, Card, Field, Input, Screen } from "../../shared/ui/index.js";
import { Shell } from "../../app/Shell.js";
import { requireAuth } from "../../app/guards.js";
import { useToast } from "../../shared/toast.js";
import { useChangePassword, useSession } from "./auth.api.js";
import { rootRoute } from "../../app/root-route.js";

export const accountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/app/account",
  beforeLoad: requireAuth(),
  component: () => (
    <Shell>
      <AccountScreen />
    </Shell>
  ),
});

function AccountScreen() {
  const { data: user } = useSession();
  const toast = useToast();
  const change = useChangePassword();
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNext] = useState("");

  return (
    <Screen title="Mon compte">
      <div className="flex flex-col gap-6">
        <Card>
          <h2 className="font-serif text-lg text-stone-900">Identité</h2>
          <dl className="mt-3 grid grid-cols-[auto_1fr] gap-x-6 gap-y-1 text-sm">
            <dt className="text-stone-500">Nom</dt>
            <dd className="text-stone-800">{user?.name}</dd>
            <dt className="text-stone-500">Email</dt>
            <dd className="text-stone-800">{user?.email}</dd>
            <dt className="text-stone-500">Rôle</dt>
            <dd className="text-stone-800">
              {user?.role === "admin" ? "Administrateur" : "Client"}
            </dd>
          </dl>
        </Card>

        <Card>
          <h2 className="font-serif text-lg text-stone-900">Mot de passe</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              change.mutate(
                { currentPassword, newPassword },
                {
                  onSuccess: () => {
                    setCurrent("");
                    setNext("");
                    toast("Mot de passe mis à jour");
                  },
                  onError: (err) =>
                    toast(err instanceof ApiError ? err.message : "Erreur", "err"),
                },
              );
            }}
            className="mt-4 flex max-w-sm flex-col gap-3"
          >
            <Field label="Mot de passe actuel">
              <Input
                type="password"
                required
                value={currentPassword}
                onChange={(e) => setCurrent(e.target.value)}
              />
            </Field>
            <Field label="Nouveau mot de passe (8 caractères min.)">
              <Input
                type="password"
                required
                minLength={8}
                value={newPassword}
                onChange={(e) => setNext(e.target.value)}
              />
            </Field>
            <div>
              <Button type="submit" disabled={change.isPending}>
                Mettre à jour
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </Screen>
  );
}
